<template>
    <rkm-form
        show-legend
    >
        <CidadaoBusca
            :additionals="additionals"
            :data-atual="form.dataAtual"
            :on-continue="onContinue"
            :termos-invalidos="form.termosInvalidos"
            @form-change="$emit('form-change', $event)"
            @searching="$emit('searching', $event)"
            @select-cidadao="$emit('select-cidadao', $event)"
            @select-paciente="$router.push({ name: 'cadastro-paciente-edit', params: { id: $event.id } })"
            ref="CidadaoBusca"
            show-dnv
            show-pacientes
        />
    </rkm-form>
</template>

<script>
import CidadaoBusca from '@/components/cadastro/cidadao/Busca'

export default {
    components: { CidadaoBusca },
    props: {
        additionals: { type: Object, required: true, default: () => ({}) },
        form: { type: Object, required: true },
        onContinue: { type: Function, required: true },
    },
    methods: {
        validate() {

            return this.$refs.CidadaoBusca.validate()
        },
        reset() {

            this.$refs.CidadaoBusca.resetForms()
        },
    },
}
</script>